module.exports = __webpack_public_path__ + "img/airpa_18.0d49e134.png";